import { render, staticRenderFns } from "./widget-text.vue?vue&type=template&id=2feca5b3&scoped=true"
import script from "./widget-text.vue?vue&type=script&lang=js"
export * from "./widget-text.vue?vue&type=script&lang=js"
import style0 from "./widget-text.vue?vue&type=style&index=0&id=2feca5b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feca5b3",
  null
  
)

export default component.exports